export const CustomerStyle = {
  TypeClass: {
    'MT': 'indigo',
    'PJ': 'lime',
    'OL': 'brown',
    'TT': 'deep-orange',
    'FT': 'amber',
    'HM': 'blue',
  },
}